import type { Workspace } from "@omnabase/shared";

/** How a role id reads in the switcher and the team list: the role's name from the workspace, or a plain word for the built-ins. */
const BUILT_IN: Record<string, string> = { owner: "Owner", admin: "Admin", agent: "Agent" };
export const roleWord = (roleId: string, roles?: Workspace["roles"]) => roles?.find((r) => r.id === roleId)?.name ?? BUILT_IN[roleId] ?? roleId;
